// Generated with util/create-component.js
import TextArea from './TextArea';

export default TextArea;
